import axios from "axios";
import isNumber from "lodash/isNumber";
import heic2any from "heic2any";
import { saveAs } from "file-saver";
import ApiUrls from "../../../../../../../../api/project/ApiUrls";
import { OCR_FOLDER_NAME } from "../../../Config";
import { isEmpty } from "../../../../../../../../common/utils";

const MAX_FILE_SIZE_MB = 10; // 設置最大檔案大小為15MB
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024; // 將MB轉換為位元組
const ALLOW_FILE_TYPE = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "application/pdf",
  "image/webp",
];
const safeFunc = () => null;

function containsSpecialCharacters(str) {
  const regex = /[{}`]/;
  return regex.test(str);
}

const handleCheck = (files, onError) => {
  // 檢查是否有不允許的檔案類型
  const checkFileType = files.filter((file) => {
    const fileType = file.type;
    // eslint-disable-next-line no-use-before-define
    // const isHEICFile = isHEIC(file);
    // if (isHEICFile) {
    //   return "";
    // }
    return !ALLOW_FILE_TYPE.includes(fileType);
  });

  if (checkFileType.length > 0) {
    onError({
      id: "sna.sidetool.digitalAITool.ocr.uploading.error2",
      defaultMsg: `檔案格式僅支援：png、jpg、pdf、webp`,
    });
    return false;
  }

  // 檢查檔案名稱是否包含特殊字元
  const checkFileName = files.filter((file) =>
    containsSpecialCharacters(file.name)
  );
  if (checkFileName.length > 0) {
    onError({
      id: "sna.sidetool.digitalAITool.ocr.uploading.error3",
      defaultMsg: `The file name cannot contain the following characters: { } \``,
    });
    return false;
  }

  // file size <= 10MB，檢查檔案大小是否符合規範
  const totalSize = files
    .map((file) => file.size)
    .reduce((acc, cur) => acc + cur);

  if (!isNumber(totalSize) || totalSize > MAX_FILE_SIZE_BYTES) {
    onError({
      id: "sna.sidetool.digitalAITool.ocr.uploading.error",
      defaultMsg: "檔案超過10MB，請重新上傳檔案",
    });
    return false;
  }

  // 通過檢查
  return true;
};

const inputFileListener =
  (onSuccess = safeFunc, onError = safeFunc) =>
  (event) => {
    event.preventDefault();

    if (event.target.files) {
      const files = Array.from(event.target.files);

      const checkFileFormat = handleCheck(files, onError);
      // checkFileFormat = false, 上傳的檔案不符合規範
      if (!checkFileFormat) return;

      onSuccess({ files });
    } else {
      onError(`Get file Error!`);
    }
  };

export const readFile = (onSuccess, onError) => {
  const inputTag = document.createElement("input");
  inputTag.type = "file";
  inputTag.accept = ".jpg,.jpeg,.png,.pdf,.webp"; // 可以上傳圖片和PDF文件
  inputTag.multiple = true; // 允許多選
  inputTag.addEventListener("change", inputFileListener(onSuccess, onError));
  inputTag.click();
};

function isHEIC(file) {
  const x = file.type
    ? file.type.split("image/").pop()
    : file.name.split(".").pop().toLowerCase();

  return x === "heic";
}

const heicFileFormat = (file) => {
  let f;
  // eslint-disable-next-line no-use-before-define
  if (isHEIC(file)) {
    heic2any({
      blob: file,
      toType: "image/jpeg",
    }).then((convertedFile) => {
      // eslint-disable-next-line no-param-reassign
      convertedFile.name = `${file.name.substring(
        0,
        file.name.lastIndexOf(".")
      )}.jpg`;
      f = convertedFile;
      // return convertedFile;
    });
  }
  return f;
};

export const multiImportFile = ({ files, user }) =>
  new Promise((resolve, reject) => {
    const { uid } = user;

    const formData = new FormData();

    // ※formData 要放的是 file 物件不是字串
    files.forEach((file) => {
      // 檔名中包含空白的，以底線替換
      const replaceSpace = file.name.replaceAll(" ", "_");
      formData.append("file", file, encodeURI(replaceSpace));
    });
    formData.append("username", uid);

    axios
      .post(ApiUrls.uploadOcrFile, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        const customErr = new Error("檔案上傳失敗");
        reject(customErr);
      });
  });

export const uploadFile = async ({ user, files }) => {
  try {
    const res = await multiImportFile({
      files,
      user,
    });

    const { status } = res;
    return status;
  } catch (err) {
    return err;
  }
};

export const uploadFileApi = async ({
  user,
  onSuccess,
  onError,
  onUploadLoading,
}) => {
  const onReadSuccess = async (resObj) => {
    const { files } = resObj;
    if (onUploadLoading) onUploadLoading(true);
    //
    const uploadStatus = await uploadFile({ files, user });

    // folderName
    const folderName = files
      .map((el) => `"${el.name.replaceAll(" ", "_")}"`)
      .join(",");

    if (uploadStatus === 200) {
      onSuccess({ userId: user.uid, folderName });
      localStorage.setItem(OCR_FOLDER_NAME, folderName);
    } else {
      if (onUploadLoading) onUploadLoading(false);
      if (onError) onError({ message: uploadStatus });
    }
  };

  const onReadError = (errMessage) => {
    // error message
    if (onUploadLoading) onUploadLoading(false);
    if (onError) onError({ message: errMessage });
  };
  //
  readFile(onReadSuccess, onReadError);
};
